
import React from 'react';
import './Players.scss';
import { monsterClassFromId } from '../../monsters';
import { useSelector, useDispatch } from 'react-redux';
import { selectCurrentTurnPlayer } from '../../redux/gameSlice';
import { setOverlayPlayerIdx, togglePlayerOverlayShowing } from '../../redux/overlaySlice';

export default function Player(props) {
  const player = props.player;
  const dispatch = useDispatch();
  const isPlayerReceivingEffect = useSelector((state) => state.animation.playersReceivingEffect[player.id]);
  const isPlayerBeingDamaged = useSelector((state) => state.animation.playerBeingDamaged[player.id]);
  const curPlayer = useSelector(selectCurrentTurnPlayer);
  const showPlayerStatsOverlayCb = (playerId) => {
    return () => {
      dispatch(setOverlayPlayerIdx(playerId))
      dispatch(togglePlayerOverlayShowing());
    };
  }

  let playerClasses = [];
  if (isPlayerReceivingEffect) {
    playerClasses.push("animation-applying-effect");
  }

  if (curPlayer && player.id === curPlayer.id) {
    playerClasses.push("player-playing");
  }

  if (player.is_connected === false) {
    playerClasses.push("player-disconnected");
  }

  if (props.isItMe) {
    playerClasses.push("my-player");
  }

  let monsterDamagedClass = "";
  if (isPlayerBeingDamaged) {
    monsterDamagedClass = "monster-damaged";
  }

  if (player.health === 0) {
    return <div className="player player-dead" key={player.id}>
      <div className="player-data-container">
        <div className={`game-sprite player-monster-thumbnail ${monsterClassFromId(player.monster_id)}`}></div>
        <div className="player-stats rounded-corners">K.O.</div>
      </div>
      <p className={`player-name ${props.isItMe ? "my-player-name" : ""}`}>{player.name}</p>
    </div>;
  }

  return <div className={`player ${playerClasses.join(" ")}`} key={player.id} onClick={props.isItMe === false ? showPlayerStatsOverlayCb(player.id) : null}>
    <div className="player-data-container">
      <div className={`game-sprite player-monster-thumbnail ${monsterClassFromId(player.monster_id)} ${monsterDamagedClass}`}></div>
      <div className={`player-stats ${props.isItMe ? 'rounded-corners' : ''}`}>
        <div className="player-stat-line">
          <span className="player-stat">{player.health}</span><span className="game-sprite player-stat-icon player-hearts"></span>
          <span className="player-stat">{player.energy}</span><span className="game-sprite player-stat-icon player-energy"></span>
        </div>
        <div className="player-stat-line">
          <span className="player-stat">{player.stars}</span><span className="game-sprite player-stat-icon player-stars"></span>
          <span className="player-stat">{player.cards.length}</span><span className="game-sprite player-stat-icon player-cards"></span>
        </div>
      </div>
      {props.isItMe === false ? <div className="show-cards-container"><i className="fas fa-chevron-right"></i></div> : ""}
    </div>
    <p className={`player-name ${props.isItMe ? "my-player-name" : ""}`}>{player.name}</p>
  </div>;
}
